var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete',{attrs:{"label":_vm.valueLocal.name,"item-text":"label","item-value":"id","url":'/api/' + _vm.value.apiMethod + '/Autocomplete'},model:{value:(_vm.valueLocal.value),callback:function ($$v) {_vm.$set(_vm.valueLocal, "value", $$v)},expression:"valueLocal.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }